var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPackageFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.002,
    viewBox: "0 0 14 14.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ms-icon-data-package-filled",
    d: "M15650.506,21469.516l.545-1.449,5.949,2.221,5.949-2.221.549,1.449-6.5,2.43Zm0-3.871.545-1.449,5.949,2.221,5.949-2.221.549,1.449-6.5,2.426Zm-.5-4.6,7-3.1,7,3.1-7,3.1Z",
    transform: "translate(-15650.002 -21457.943)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPackageFilled);
export default __webpack_public_path__ + "static/media/data-package-filled.bb0ad4ce488fee964a70d7be3d5b388a.svg";
export { ForwardRef as ReactComponent };